import {fork} from "redux-saga/effects";
import pageSaga from "./pages/sagas/pageSaga";
import analyticsSaga from "./sagas/analyticsSaga";

export default function* rootSaga() {
  yield fork(pageSaga);
  yield fork(analyticsSaga);
}